export default __webpack_public_path__ + "assets/step_0.b438558f.svg";